module.exports = __webpack_public_path__ + "p_02.4a8a0804.png";